import React from 'react';
import { NavLink as RouterNavLink, Redirect, Route, Switch } from 'react-router-dom';
import { AmsPermissionClaimType, authService } from '../../services/Auth';
import PageTitle from '../../components/PageTitle';
import AllInvoicesTab from './invoices/AllInvoicesTab';
import UnsentTab from './invoices/UnsentTab';
import PaidTab from './invoices/PaidTab';
import UnpaidTab from './invoices/UnpaidTab';
import FailedTab from './invoices/FailedTab';

const InvoicesPage = (props) => {
    if (!authService.hasPermission(AmsPermissionClaimType, 'systemadmin')) {
        return <Redirect to="/profile" />;
    }

    return (
        <>
            <PageTitle title="Invoices" />

            <div className="invoices-tabs-container">
                <nav className="invoices-tab-bar">
                    <RouterNavLink exact to="/invoices" className="invoices-tab" activeClassName="invoices-tab--active">
                        All Invoices
                    </RouterNavLink>
                    <RouterNavLink to="/invoices/unsent" className="invoices-tab" activeClassName="invoices-tab--active">
                        Unsent
                    </RouterNavLink>
                    <RouterNavLink to="/invoices/paid" className="invoices-tab" activeClassName="invoices-tab--active">
                        Paid
                    </RouterNavLink>
                    <RouterNavLink to="/invoices/unpaid" className="invoices-tab" activeClassName="invoices-tab--active">
                        Unpaid
                    </RouterNavLink>
                    <RouterNavLink to="/invoices/failed" className="invoices-tab" activeClassName="invoices-tab--active">
                        Failed
                    </RouterNavLink>
                </nav>

                <Switch>
                    <Route exact path="/invoices" render={(routeProps) => <AllInvoicesTab {...routeProps} />} />
                    <Route path="/invoices/unsent" component={UnsentTab} />
                    <Route path="/invoices/paid" component={PaidTab} />
                    <Route path="/invoices/unpaid" component={UnpaidTab} />
                    <Route path="/invoices/failed" component={FailedTab} />
                </Switch>
            </div>
        </>
    );
};

export default InvoicesPage;
